export default (state: IKeyValue) => ({
	token: state.token,
	user: state.user,
});
